import React, { useEffect, useMemo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay } from "swiper";

import i1 from "../../../../../assets/images/gallerycarousel/1.webp";
import i2 from "../../../../../assets/images/gallerycarousel/2.webp";
import i3 from "../../../../../assets/images/gallerycarousel/3.webp";
import i4 from "../../../../../assets/images/gallerycarousel/4.webp";
import i41 from "../../../../../assets/images/gallerycarousel/4.5.webp";
import i42 from "../../../../../assets/images/gallerycarousel/4.6.webp";
import i43 from "../../../../../assets/images/gallerycarousel/4.7.webp";
import i44 from "../../../../../assets/images/gallerycarousel/4.8.webp";
import i45 from "../../../../../assets/images/gallerycarousel/4.9.webp";
import i46 from "../../../../../assets/images/gallerycarousel/4.10.webp";
import i5 from "../../../../../assets/images/gallerycarousel/5.webp";
import i6 from "../../../../../assets/images/gallerycarousel/6.webp";
import i7 from "../../../../../assets/images/gallerycarousel/7.webp";
import i8 from "../../../../../assets/images/gallerycarousel/8.webp";
import i8a from "../../../../../assets/images/gallerycarousel/8a.webp";
import i9 from "../../../../../assets/images/gallerycarousel/9.webp";
import i10 from "../../../../../assets/images/gallerycarousel/10.webp";
import i11 from "../../../../../assets/images/gallerycarousel/11.webp";
import i112 from "../../../../../assets/images/gallerycarousel/11.7.webp";
import i113 from "../../../../../assets/images/gallerycarousel/11.6.webp";
import i114 from "../../../../../assets/images/gallerycarousel/11.5.webp";
import i12 from "../../../../../assets/images/gallerycarousel/12.webp";
import i13 from "../../../../../assets/images/gallerycarousel/13.webp";
import i50 from "../../../../../assets/images/gallerycarousel/50.webp";
import i52 from "../../../../../assets/images/gallerycarousel/52.webp";
import i53 from "../../../../../assets/images/gallerycarousel/53.webp";
import i55 from "../../../../../assets/images/gallerycarousel/55.webp";
import i17 from "../../../../../assets/images/gallerycarousel/17.webp";
import i18 from "../../../../../assets/images/gallerycarousel/18.webp";
import i19 from "../../../../../assets/images/gallerycarousel/19.webp";
import i20 from "../../../../../assets/images/gallerycarousel/20.webp";
import i21 from "../../../../../assets/images/gallerycarousel/21.webp";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../../../../sass/files/galleryslider.scss";

const CATEGORIES = [
  "All",
  "Likeness",
  "Hardsurface",
  "Cartoon",
  "Animal",
  "Action Figure",
  "Concept Art",
  "Relief",
];

const GALLERY_ITEMS = [
  {
    id: "likeness-1",
    src: i1,
    cat: "Likeness",
    title: "Portrait Likeness",
  },
  {
    id: "likeness-2",
    src: i3,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-3",
    src: i41,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-4",
    src: i42,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-5",
    src: i43,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-6",
    src: i44,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-7",
    src: i45,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-8",
    src: i46,
    cat: "Likeness",
    title: "Studio Bust",
  },
  {
    id: "likeness-9",
    src: i5,
    cat: "Likeness",
    title: "Bearded Likeness",
  },
  {
    id: "likeness-10",
    src: i4,
    cat: "Likeness",
    title: "Bearded Likeness",
  },
  {
    id: "likeness-11",
    src: i6,
    cat: "Likeness",
    title: "Bearded Likeness",
  },
  {
    id: "likeness-12",
    src: i2,
    cat: "Likeness",
    title: "Bust Likeness",
  },

  {
    id: "concept-1",
    src: i7,
    cat: "Concept Art",
    title: "Concept Character",
  },
  {
    id: "concept-2",
    src: i8,
    cat: "Concept Art",
    title: "Concept Sculpt",
  },
  {
    id: "concept-3",
    src: i8a,
    cat: "Concept Art",
    title: "Character Concept",
  },
  {
    id: "concept-4",
    src: i9,
    cat: "Concept Art",
    title: "Original Concept",
  },

  {
    id: "hardsurface-1",
    src: i10,
    cat: "Hardsurface",
    title: "Prop / Jetpack",
  },
  {
    id: "hardsurface-2",
    src: i11,
    cat: "Hardsurface",
    title: "Vehicle / Part",
  },
  {
    id: "hardsurface-3",
    src: i112,
    cat: "Hardsurface",
    title: "Vehicle / Part",
  },
  {
    id: "hardsurface-4",
    src: i113,
    cat: "Hardsurface",
    title: "Vehicle / Part",
  },
  {
    id: "hardsurface-5",
    src: i114,
    cat: "Hardsurface",
    title: "Vehicle / Part",
  },

  {
    id: "animal-1",
    src: i12,
    cat: "Animal",
    title: "Pet Cartoon",
  },
  {
    id: "animal-2",
    src: i13,
    cat: "Animal",
    title: "Stylized Head",
  },

  {
    id: "relief-1",
    src: i50,
    cat: "Relief",
    title: "Custom Relief",
  },
  {
    id: "relief-2",
    src: i52,
    cat: "Relief",
    title: "Sculpted Relief",
  },
  {
    id: "relief-3",
    src: i53,
    cat: "Relief",
    title: "Custom Relief",
  },
  {
    id: "relief-4",
    src: i55,
    cat: "Relief",
    title: "Sculpted Relief",
  },

  {
    id: "cartoon-1",
    src: i19,
    cat: "Cartoon",
    title: "Cartoon Character",
  },
  {
    id: "cartoon-2",
    src: i20,
    cat: "Cartoon",
    title: "Stylized Cartoon",
  },
  {
    id: "cartoon-3",
    src: i21,
    cat: "Cartoon",
    title: "Custom Cartoon",
  },

  {
    id: "action-1",
    src: i17,
    cat: "Action Figure",
    title: "Action Figure",
  },
  {
    id: "action-2",
    src: i18,
    cat: "Action Figure",
    title: "Action Figure",
  },
];

const GalleryCarousel = () => {
  const [activeCat, setActiveCat] = useState("All");

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }

    return window.matchMedia("(max-width: 576px)").matches;
  });

  useEffect(() => {
    const mobileQuery = window.matchMedia("(max-width: 576px)");

    const handleDeviceChange = (event) => {
      setIsMobile(event.matches);
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", handleDeviceChange);
    } else {
      mobileQuery.addListener(handleDeviceChange);
    }

    return () => {
      if (mobileQuery.removeEventListener) {
        mobileQuery.removeEventListener("change", handleDeviceChange);
      } else {
        mobileQuery.removeListener(handleDeviceChange);
      }
    };
  }, []);

  const filteredItems = useMemo(() => {
    if (activeCat === "All") {
      return GALLERY_ITEMS;
    }

    return GALLERY_ITEMS.filter(
      (item) => item.cat === activeCat
    );
  }, [activeCat]);

  return (
    <section
      className="gallery-carousel-layout"
      aria-label="3D modelling gallery"
    >
      <div
        className="gallery-categories"
        role="group"
        aria-label="Gallery categories"
      >
        {CATEGORIES.map((category) => (
          <button
            key={category}
            type="button"
            className={`category-pill ${
              activeCat === category ? "is-active" : ""
            }`}
            onClick={() => setActiveCat(category)}
            aria-pressed={activeCat === category}
          >
            <span>{category}</span>
          </button>
        ))}
      </div>

      <div className="gallery-carousel-track">
        <Swiper
          key={activeCat}
          className="mySwiper"
          modules={[
            Navigation,
            Pagination,
            A11y,
            Autoplay,
          ]}
          slidesPerView={1.08}
          spaceBetween={12}
          centeredSlides={true}
          grabCursor={!isMobile}
          watchOverflow={true}

          /*
           * Desktop keeps infinite loop.
           * Mobile loop is disabled to prevent duplicate slides
           * from consuming too much iPhone memory.
           */
          loop={!isMobile && filteredItems.length > 3}

          /*
           * Prevent Swiper from preloading every image.
           */
          preloadImages={false}

          speed={isMobile ? 550 : 750}

          /*
           * Autoplay is enabled everywhere.
           * Mobile is slower to reduce iPhone workload.
           */
          autoplay={
            filteredItems.length > 1
              ? {
                  delay: isMobile ? 4000 : 2600,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  waitForTransition: true,
                }
              : false
          }

          navigation={!isMobile && filteredItems.length > 1}

          pagination={
            !isMobile
              ? {
                  clickable: true,
                  dynamicBullets: true,
                }
              : false
          }

          breakpoints={{
            577: {
              slidesPerView: 1.4,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 2.05,
              spaceBetween: 18,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
        >
          {filteredItems.map((item) => (
            <SwiperSlide key={item.id}>
              <figure className="gallery-card">
                <img
                  className="gallery-card-image"
                  src={item.src}
                  alt={`${item.title} — custom 3D modelling by 3D Spot`}
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                  draggable="false"
                />

              </figure>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default GalleryCarousel;